<template >
  <section>
    <TopMenu/>
    <CardDefault title="Ferramentas" icon="hammer-outline">
      <div class="padding-null d-flex flex-column grid-two-columns col-md-6">
          <AccountantTool />
          <MarqtabAccess />
          <DuplicateDays />
          <!-- <EnableBenefits /> -->
          <!-- <GenerateFileACJEF /> -->
        </div>

        <div class="padding-null d-flex flex-column grid-two-columns col-md-6">
          <SwitchWorkShiftToSchedule />
          <UnlockScale />
          <!-- <DualAccess /> -->
          <!-- <ConfigureDualRole /> -->
          <!-- <WorkShiftTimeZoneTool/> -->
        </div>
    </CardDefault>
  </section>
</template>

<script>
import TopMenu from "../../components/default/topMenu.vue";
import AccountantTool from "./supportItems/accountantTool.vue";
import WorkShiftTimeZoneTool from "./supportItems/workShiftTimeZoneTool.vue";
import SwitchWorkShiftToSchedule from "./supportItems/switchWorkShiftToSchedule.vue";
import DuplicateDays from "./supportItems/duplicateDays.vue";
import UnlockScale from "./supportItems/unlockScale.vue";
import MarqtabAccess from "./supportItems/marqtabAccess.vue";
import DualAccess from "./supportItems/dualAccess.vue";
import CardDefault from "../../components/layouts/cardDefault/index.vue";
import EnableBenefits from "./supportItems/enableBenefits.vue";
import ConfigureDualRole from "./supportItems/configureDualRole.vue";
import GenerateFileACJEF from "./supportItems/generateFileACJEF.vue";

export default {
  name: "support-tools",
  components: {
    TopMenu,
    CardDefault,
    AccountantTool,
    WorkShiftTimeZoneTool,
    SwitchWorkShiftToSchedule,
    UnlockScale,
    MarqtabAccess,
    DuplicateDays,
    DualAccess,
    ConfigureDualRole,
    GenerateFileACJEF,
    EnableBenefits,
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss">

* {
  font-family: "Montserrat", sans-serif !important;
}

.grid-two-columns{
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.input-with-date {
  width: 100%;

  input {
    width: 100%;
  }
}


</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportTools.vue